type Tag = 'u' | 's' | 'em' | 'b' | 'code';

const SPOILER_PATTERN = '<spoiler>((?:.|\n)*?)</spoiler>';

const SPOILER_REG_EXP_GLOBALLY = new RegExp(SPOILER_PATTERN, 'g');

export const divideSpoilers = (text: string) => {
  const tags: Tag[] = ['u', 's', 'em', 'b', 'code'];
  const str = text.replace(SPOILER_REG_EXP_GLOBALLY, (match, p1) => {
    // html внутри тега spoiler делим на строки
    const htmlLines = p1.split('\n');
    // массив открывающих тегов, будет хранить открытые на предыдущих строках теги, при закрытии тега, он будет удаляться из массива
    let openTags: Tag[] = [];
    /**
     * Для каждого вида тега добавляем недостающий закрывающий или открывающий тег, обновляем содержание openTags
     * @param str строка
     * @param openTagsForNextLines массив тегов, которые открыты, но не закрыты на этой строке. Соответственно, их разметка должна учитываться на следующей строке
     */
    const closeAndOpenTags = ({
      str,
      tag,
      openTagsForNextLines
    }: {
      str: string;
      tag: Tag;
      openTagsForNextLines: Tag[];
    }): { str: string; openTagsForNextLines: Tag[] } => {
      const closingTag = `</${tag}>`;
      const openingTag = `<${tag}>`;
      const closingTagRegex = new RegExp(closingTag);
      const openingTagRegex = new RegExp(openingTag);

      const closingTagIndex = str.indexOf(closingTag);
      // Если в строке нет закрывающего тега ищем открывающий тег
      if (closingTagIndex === -1) {
        // если есть открывающий тег, добавляем закрывающий тег
        if (openingTagRegex.test(str)) {
          openTagsForNextLines.push(tag);
          return { str: str + closingTag, openTagsForNextLines };
        }
        return { str, openTagsForNextLines };
      }
      // если есть закрывающий тег
      let resultStr = str;

      // если нет открывающего тега до него
      if (!openingTagRegex.test(str.substring(0, closingTagIndex))) {
        // Удаляем из массива открывающих тегов
        const index = openTags.indexOf(tag);
        if (index !== -1) {
          openTags.splice(index, 1);
        }
        // добавляем открывающий тег
        resultStr = openingTag + str;
      }
      // проверяем нет ли открывающего тега после закрывающего
      const substr = str.substring(closingTagIndex);
      const openingTagIndex = substr.lastIndexOf(openingTag);

      // если есть открывающий тег и нет закрывающего после него
      if (
        openingTagIndex !== -1 &&
        !closingTagRegex.test(substr.substring(openingTagIndex))
      ) {
        openTagsForNextLines.push(tag);
        return { str: resultStr + closingTag, openTagsForNextLines };
      }

      return { str: resultStr, openTagsForNextLines };
    };

    const lines = htmlLines.map((line, index) => {
      const {
        str,
        openTagsForNextLines
      }: { str: string; openTagsForNextLines: Tag[] } = tags.reduce(
        (acc, tag) => {
          return closeAndOpenTags({ tag, ...acc });
        },
        { str: line, openTagsForNextLines: [] as Tag[] }
      );

      let resultStr = str;

      if (index > 0 && index < htmlLines.length - 1) {
        // если в openTags есть незакрытые теги, оборачиваем  в них строку
        openTags.forEach((tag) => {
          resultStr = `<${tag}>${resultStr}</${tag}>`;
        });
      }
      // обновляем массив открывающих тегов для следующих строк
      openTags = [...openTags, ...openTagsForNextLines];

      return `<spoiler>${resultStr}</spoiler>`;
    });
    return lines.join('\n');
  });
  return str;
};
